<template>
<div v-if="choices.length"
	class="choices"
	:class="{
		'inactive': !active,
		'not-subbed': !account.props.sub
	}"
>
	<div class="flex-parent">
		<div style="width:50%">
			<h3>Subscriber Bonus choice</h3>
			<p v-if="account.priv.choiceUsed">
				<strong>You've selected a Subscriber Choice for this month</strong>
			</p>
			<p v-else-if="active">
				<span v-if="account.props.sub">You</span><span v-else>Active <a @click.prevent="openSettings()"><em>God Mode</em> subscribers</a></span> may choose one of the options below
			</p>
			<p v-else-if="!ended">
				Active <a @click.prevent="openSettings()"><em>God Mode</em> subscribers</a> will be able to choose one of the options below
			</p>
		</div>
		<countdown v-if="choices.length"
			:start="startDate"
			:end="endDate"
			class="right-text"
			style="width:50%"
			@updateActive="updateActive"
			@updateEnded="updateEnded"
		/>
	</div>
	<div v-if="!ended">
		<div v-if="!account.priv.choiceUsed" class="flex-parent">
			<choice v-for="(choice, index) in choices" :key="index" :choice="choice" :index="index" />
			<!--<div class="perk">
					<div class="choice pad border">
						<h4>Character Emoji slot(s)</h4>
						<div class="center-text preview">
							<img src="https://img.rphaven.com/emoji-preview.png" style="width:100%" />
						</div>
						<p>Replace any and all of the dozens of Smileys & Emotion and People & Body emojis with your own custom PNGs!</p>
						<p><strong>One</strong> <span class="permanent highlight" title="Permanent choices may still be used even if your subscription expires in the future">permanent</span> character emoji slot.</p>
						<p><sub>Quintupled to <strong>five</strong> slots when you're an active subscriber!</sub></p>
						<div class="center-text bottom pad-top">
							<a class="button">Choose Character Emoji Slot</a>
						</div>
					</div>
				</div>-->
		</div>
		<p v-if="!account.priv.choiceUsed">
			<a @click.prevent="openSettings()"><em>God Mode</em> subscribers</a> may make a choice <span v-if="active">now</span><span v-else>within two weeks following {{ makeTimestamp12hr(startDate) }}</span>. If a choice is not made by {{ makeTimestamp12hr(endDate) }}, your choice will default to this month's <span class="exclusive highlight" title="Exclusive choices are limited to this month's subscriber bonus choice and won't appear as an option in a future choice">Exclusive</span> option, or the first option if there is no <em>exclusive</em> option.
		</p>
	</div>
</div>
</template>

<script>
import Countdown from './countdown.vue'
import Choice from './choice.vue'
import { makeTimestamp12hr, makeSafeForCss } from '../js/shared/common-functions.js'
import {ref} from 'vue'
import perks from '../js/shared/perks.js'

const subscriberChoice = perks.CHOICES.find( ( block ) => {
	return block.endDate > Date.now()
}) || {startDate: false, endDate: false, choices: []}

export default {
	components: {
		countdown: Countdown,
		choice: Choice
	},
	props: {
		account: {
			type: Object,
			required: true
		}
	},
	setup( props ){
		/* const { data.startDate, data.endDate, choices } = props.data // destructuring removes reactivity, but not needed here
			return {
				data.startDate,
				data.endDate,
				choices
			} */
		const now = new Date().getTime()

		console.log( 'setup', props, this )

		return {
			now: now,
			ended: ref( now > subscriberChoice.endDate ),
			active: ref( now > subscriberChoice.startDate && now < subscriberChoice.endDate )
		}
	},
	data: () => ({
		now: new Date().getTime(),
		active: ref( false ),
		ended: ref( false ),
		endDate: subscriberChoice.endDate,
		startDate: subscriberChoice.startDate,
		choices: subscriberChoice.choices
	}),
	methods: {
		openSettings: () => {
			$( '#settings-dialog' ).show()
				.find( '.tabs a[href="#account-settings"]' ).click()
		},
		updateActive( bool ){
			this.active = bool
		},
		updateEnded( bool ){
			this.ended = bool
		},
		makeTimestamp12hr: makeTimestamp12hr
	}
}
</script>